import {Injectable} from '@angular/core';
import {plainToClass} from 'class-transformer';

import {EnergyLevelEveningBadgeType} from 'shared/models/badges/energy-level-evening-badge-type';
import {EnergyLevelMorningBadgeType} from 'shared/models/badges/energy-level-morning-badge-type';
import {MorningImpulseBadgeType} from 'shared/models/badges/morning-impulse-badge-type';
import {PerformanceLevelBadgeType} from 'shared/models/badges/performance-level-badge-type';
import {BadgeType} from 'shared/models/badges/badge-type';

@Injectable()
export class BadgeTypeFactoryService {

  public createBadgeType(name: string, data?: BadgeType): BadgeType {
    data = data || <BadgeType> {};
    let badgeType: BadgeType;

    if (name === 'morningImpulse') {
      badgeType = plainToClass(MorningImpulseBadgeType, data);
    } else if (name === 'energyLevelMorning') {
      badgeType = plainToClass(EnergyLevelMorningBadgeType, data);
    } else if (name === 'energyLevelEvening') {
      badgeType = plainToClass(EnergyLevelEveningBadgeType, data);
    } else     if (name === 'performanceLevel') {
      badgeType = plainToClass(PerformanceLevelBadgeType, data);
    } else {
      throw new Error(`Unknown badge typ '${name}'`);
    }

    return badgeType;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/badges/services/badge-type-factory.service.ts